<template>
  <div class="vx-col w-full">
    <form data-vv-scope="application">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div class="vx-col w-full">
            <vx-card title="Update Guarantor">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Name</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="text" v-model="name" v-validate="'required'"
                            data-vv-as="Name" name="name"/>
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Mobile</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    type="tel"
                    v-validate="'required|min:11|max:11'"
                    data-vv-validate-on="blur"
                    name="mobile"
                    v-model="mobile"
                    @keypress="onlyNumber"
                    data-vv-as="Mobile"
                    class="w-full"/>
                  <span class="text-danger text-sm" v-show="errors.has('mobile')">{{ errors.first('mobile') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" type="email" v-model="email"
                            v-validate="'email'" data-vv-as="Email" name="email"/>
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Relationship</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <template>
                    <v-select label="text" v-model="relationship"
                              class="w-full select-large" v-validate="'required'" data-vv-as="Relationship"
                              name="relationship"
                              :options="guarantorRelation" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </template>
                  <span class="text-danger text-sm" v-show="errors.has('relationship')">{{ errors.first('relationship') }}</span>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button  color="rgb(0 121 193)" class="mr-3 mb-2 float-right" @click="savaGuarantor()">Update
                  </vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import {productsQuery} from '../graphql/products'
  import updatePurchaseGuarantor from '../graphql/UpdatePurchaseGuarantor.gql'
  import {onLogin} from '../vue-apollo'
  import {ME} from '../graphql/userinfo'
  import gql from 'graphql-tag'

  const divisionsQuery = gql`
  query divisions {
    divisions{
    id
    division
    districts{
      id
      district
      showrooms{
        id
        suffix
        emp_id
        manager_name
        phone
        email
        address
      }
    }
  }
}`

  export default {
    data () {
      return {
        name:'',
        mobile:'',
        email:'',
        relationship:'',
        guarantorRelation: ['Co-worker', 'Landlord / Tenant', 'Others']
      }
    },
    apollo: {
      GuarantorByID: {
        query: gql`
         query GuarantorByID($id: ID!){
          GuarantorByID(id:$id){
            id
            name
            phone
            email
            relationship
          }
         }
         `,
        variables () {
          return {
            id: this.$route.params.guarantorId
          }
        },
        update: (data) => data.GuarantorByID
      }

    },
    watch: {
      GuarantorByID (value) {
        console.log('GuarantorByID : =', value);
        this.name = value.name
        this.email = value.email
        this.mobile = value.phone
        this.relationship = value.relationship
      }
    },
    /*apollo: {
      meQuery: {
        query: ME,
        manual: true,
        result ({data, loading}) {
          if (!loading) {
            this.userInfo = data.me
            this.guarantors = this.userInfo.guarantors
            console.log('Meeeee', this.guarantors)
          }
        }
      },

      productQuer: {
        query: productsQuery,
        manual: true,
        result ({data, loading}) {
          if (!loading) {
            this.allproducts = data.products
            console.log('Product', this.allproducts)
          }
        }
      }
    },*/
    // apollo: {
    //   products: {
    //     query: productQuery,
    //   },
    // },
    /*watch: {
      divisions (value) {
        this.branchDevision = value
        console.log('division:', this.branchDevision)
      },
      meQuery (value) {
        this.userinfos = value
        console.log('Userinfos', this.userinfos)
        //this.$apollo.queries.meQuery.refetch();
      }
    },*/
    methods: {
      savaGuarantor () {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('application').then(result => {
            if (result) {
              this.submitGuarantor()
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
        })
      },
      async submitGuarantor () {
        console.log('Showrooms = ', this.showroom)
        console.log('Product = ', this.product)
        await this.$apollo.mutate({
          mutation: updatePurchaseGuarantor,
          variables: {
            id: this.$route.params.purchaseId,
            guarantor_id: this.$route.params.guarantorId,
            name: this.name,
            phone: this.mobile,
            email: this.email,
            relationship: this.relationship,
          }
        }).then((data) => {
          console.log('Dep Data = ', data)
          //this.$apollo.queries.user.refetch();
          this.$router.push('/applicantDashboard').catch(() => {
          })
          this.$vs.notify({
            title: ' Saved',
            text: 'Successfully Submitted.',
            color: 'success',
            position: 'top-right'
          })
        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: 'danger',
            position: 'top-right'
          })
        })
      },

      onlyNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect
    }
  }
</script>
